import React from "react";
import { DraggableScrollContainer } from "../../atom/DraggableScrollContainer";
import { SectionHeading } from "../../atom/SectionHeading";
import { CornerUser } from "../../atom/CornerUser";
import { useTranslation } from "react-i18next";
import { Button } from "../../atom/Button";
import { ArrowRight } from "@carbon/icons-react";
import { RecentPracticeExams } from "./RecentPracticeExams";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../utils/consts/routes";
import { useUserContext } from "../../../utils/contexts/UserProvider";
import { usePostResource } from "../../../services";
import { GenerateParticipantExamRequestResponse } from "../../../types/components";

export const Practice = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUserContext();

  const { updateResource } = usePostResource(
    `/common/generate-participant-exam-request?include=participant_exam,participant_exam.exam`,
  );

  const handleClick = async () => {
    if (!user) return;

    const resp: GenerateParticipantExamRequestResponse = await updateResource();
    const participantExamId = resp?.data?.participant_exam?.id;
    const examId = resp?.data?.participant_exam?.exam.id;

    if (participantExamId) {
      navigate(ROUTES.exam, { state: { examId: participantExamId, id: examId, isPractice: true } });
    }
  };

  return (
    <div className="flex flex-col flex-1 items-center w-full flex-grow">
      <div className="w-full overflow-hidden flex flex-col flex-grow">
        <DraggableScrollContainer className="m-[20px] overflow-y-auto select-none ml-[8px] bg-gray-100 flex-grow">
          <div className="flex flex-col gap-10">
            <div className="px-12 pt-10 flex flex-col gap-y-8">
              <SectionHeading
                title={t("Practice")}
                subtitle={t("Take a practice exam to see where you stand and what to focus on.")}
                subtitleClassName="max-w-[560px]"
                cornerComponent={<CornerUser />}
              />
              <Button
                type="primary"
                label={t("Run Practice Exam")}
                leftIcon={<ArrowRight size={20} />}
                additionalClassName="flex items-center justify-center w-fit"
                onClick={handleClick}
              />
            </div>
            <RecentPracticeExams />
          </div>
        </DraggableScrollContainer>
      </div>
    </div>
  );
};
